import cookies from "@/config/cookies";
import {
	checkIfLocaleIsCSE,
	getCurrentLocale,
	checkIfCompanyIsCgos,
} from "@/utils/utils";

export const cookie_setParticipantsAges = (arr) => {
	const currentLocale = getCurrentLocale();
	if (!currentLocale) throw new Error("currentLocale cannot be undefined")
	const isCSE = checkIfLocaleIsCSE(currentLocale);
	const isCompanyCgos = checkIfCompanyIsCgos();

	const participantsAgesNoEncodingCookie = `${cookies.PARTICIPANTS_AGES_NO_ENCODING}=${arr};path=/`;
	const participantsAgesCookie = `${cookies.PARTICIPANTS_AGES}=${encodeURI(
		JSON.stringify(arr)
	)};path=/`;

	// if (!isCSE || (isCSE && isCompanyCgos)) {
	document.cookie = participantsAgesNoEncodingCookie;
	document.cookie = participantsAgesCookie;
	// }
};
export const cookie_setParticipantsNum = (num) => {
	document.cookie = `${cookies.PARTICIPANTS_NUM}=${num}`;
};
